function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import React, { memo, forwardRef } from 'react';
import PropTypes from 'prop-types';
export const Body = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  TbodyComponent,
  children,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement(TbodyComponent, _extends({}, rest, {
    ref: ref
  }), children);
}));
Body.displayName = 'Body';
Body.propTypes = {
  // add your proptypes here
  // cells: PropTypes.array.isRequired,
};